import { createContext, useContext, useState, useEffect } from 'react';

const MoanaPayeContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export function MoanaPayeProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('mp_token'));
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState(null);
  const [formule, setFormule] = useState(null);

  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.app === 'moana_paye' && payload.exp * 1000 > Date.now()) {
          setUser(payload);
        } else {
          logout();
        }
      } catch {
        logout();
      }
    }
    setLoading(false);
  }, [token]);

  const loadPermissions = async (eid) => {
    if (!token || !eid) return;
    try {
      const res = await fetch(`${API}/api/moana-paye/entreprises/${eid}/permissions`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setPermissions(data.permissions);
        setFormule(data.formule);
      }
    } catch { /* silently fail */ }
  };

  const can = (perm) => {
    if (!permissions) return true; // loading or admin bypass
    return permissions[perm] !== false;
  };

  const login = async (email, password) => {
    const res = await fetch(`${API}/api/moana-paye/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Erreur de connexion');
    localStorage.setItem('mp_token', data.token);
    setToken(data.token);
    setUser({ ...data.user, sub: data.user.id, profil: data.user.profil });
    return data;
  };

  const logout = () => {
    localStorage.removeItem('mp_token');
    setToken(null);
    setUser(null);
  };

  const mpFetch = async (path, options = {}) => {
    const res = await fetch(`${API}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers
      }
    });
    if (res.status === 401) { logout(); throw new Error('Session expiree'); }
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Erreur serveur');
    return data;
  };

  return (
    <MoanaPayeContext.Provider value={{ user, token, loading, login, logout, mpFetch, permissions, formule, can, loadPermissions }}>
      {children}
    </MoanaPayeContext.Provider>
  );
}

export const useMoanaPaye = () => useContext(MoanaPayeContext);
